import { BLOG_API } from '@common/consts';

export default {
  GET_CURRENCY_LIST: '/v2/asset/currency/detail/list',
  GET_CURRENCY_DETAIL: '/v2/asset/currency/detail',
  GET_CURRENCY_PUBLIC_INFO: '/v2/asset/currency/detail/public',
  GET_CURRENCY_PERFORMANCE_INFO: '/v2/asset/currency/detail/performance',
  GET_CURRENCY_CANDLES_DATA: '/v2/asset/currency/detail/candles',
  GET_CURRENCY_LATEST_PRICE: '/v2/asset/currency/detail/latest-price',
  GET_BLOG_TAGS: `${BLOG_API}/tags?hide_empty=true&per_page=100`,
  GET_BLOG_BY_TAGS: `${BLOG_API}/posts?tags=`,
  GET_MARKET_REPORT_BLOG: `${BLOG_API}/posts`,
};
